import { Component, OnInit, Renderer2, Inject } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['../error.component.scss']
})
export class pageNotFoundComponent implements OnInit {

  constructor() {
  
  }

  ngOnInit() {

  }
}
